module.exports = __webpack_public_path__ + "img/rm.067574e0.png";